"use client";

import styles from './index.module.scss';
import {useCallback, useState} from "react";
import Image from "next/image";
import AddIcon from "@/app/icons/add.svg";
import RemoveIcon from "@/app/icons/remove.svg";

export default function Accordion({
    children,
    title,
    defaultShow = false,
   }) {
    const [show, setShow] = useState(defaultShow);

    const toggleShow = useCallback(() => {
        setShow(!show);
    }, [show, setShow]);

    return (
        <div className={styles.accordion}>
            <div onClick={toggleShow} className={styles.header}>
                <h2>{title}</h2>
                <div className={styles.icon}>
                    {show ? <Image src={RemoveIcon} alt="Remove" /> : <Image src={AddIcon} alt="Add" />}
                </div>
            </div>
            {
                show && (
                    <div className={styles.content}>
                        {children}
                    </div>
                )
            }
        </div>
    );
}